import React from 'react';
import { Reveal } from '../ui/Reveal';
import SafeIcon from '../common/SafeIcon';

const stats = [
  { icon: "Clock", value: "35+ Years", label: "Industry Experience", desc: "Decades of localized market knowledge and defensible valuations." },
  { icon: "CheckCircle", value: "MAI Certified", label: "Highest Designation", desc: "Adhering to strict professional appraisal standards." },
  { icon: "Percent", value: "1,000+", label: "Properties Appraised", desc: "Extensive portfolio across all commercial property types." }
];

const StatsRow = () => {
  return (
    <section className="bg-charcoal-950 py-20 border-b border-white/5 relative z-20">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 text-center">
          {stats.map((stat, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="flex flex-col items-center">
                {/* Circular Gold Icon */}
                <div className="w-20 h-20 rounded-full border-2 border-gold-500 flex items-center justify-center mb-6">
                  <SafeIcon name={stat.icon} className="text-gold-500 text-3xl" />
                </div>
                
                <h3 className="text-gold-500 text-xl font-bold mb-2">{stat.value}</h3>
                <h4 className="text-white font-semibold mb-3">{stat.label}</h4>
                <p className="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto">
                  {stat.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsRow;